<div class="bfx-atdl-designer">
  <!-- BODY -->
  <div class="atdl-body" fxLayout="row" fxFlex="grow" fxLayoutGap="8px">
    <!-- Row with 2 columns , one for ATDL Input, the other for the result-->
    <div fxFlex="grow" fxLayout="column">
      <div id="atdl-text-container" fxFlex="grow" class="adtl-text-container">
        <textarea
          fxFlex="1 1 100%"
          id="atdl-text"
          class="atdl-text"
          [(ngModel)]="data.atdlText"
          placeholder="Paste ATDL Text Here"
        ></textarea>
      </div>

      <div>
        <!-- ATDL Footer action and info panel -->
        <span fxFlex="1 1" class="atdl-load-error"> {{data.error}} </span>
        <div class="atdl-text-footer">
          <button pButton class="bfx-button-primary" (click)="loadATDL()">LOAD</button>
        </div>
      </div>
    </div>
    <div fxFlex="530px" fxLayout="column">
      <!-- ALGO STRATEGY PARAMETERS PANEL  -->
      <p-splitter
        minSizes="[5,5]"
        fxFlex="grow"
        #fixings
        [style]="{
        'height': '100%',
        'overflow': 'hidden'
      }"
        layout="vertical"
      >
        <ng-template pTemplate>
          <!-- Bottom pane is either the parameters table or a list of validation errors-->
          <div class="atdl-form" style="width: 100%">
            <atdl-designer-params
              #panelAlgoParams
              [entryType]="1"
              [algoType]="data.algoType"
              [atdlModel]="data.atdlModel"
              [ccyCode]="data.currencyCode"
              [orderAmt]="data.orderAmount"
              [ccyPairCode]="data.currencyPair"
              [ccyPairInverted]="data.invertedPair"
              [rate]="data.rate"
              [strategyParameters]="data.strategyParameters"
              [suppressWindowResizeUpdates]="true"
              scrollMaxHeight="3000"
              (onChange)="parametersChanged($event)"
            >
              <!-- 
          [(requestRate)]="" 
         -->
            </atdl-designer-params>
          </div>
        </ng-template>
        <ng-template pTemplate>
          <!-- grid for parameter values-->
          <div *ngIf="!data.hasValidationErrors" style="width: 100%; height: 100%">
            <ag-grid-angular
              class="ag-bcdfx"
              style="width: 100%; height: 100%"
              enableColResize
              enableSorting
              [columnDefs]="columnDefs"
              [gridOptions]="gridOptions"
              [showToolPanel]="false"
            >
            </ag-grid-angular>
          </div>
          <div class="atdl-validation-errors-container" fxFlex *ngIf="data.hasValidationErrors">
            <!-- WARNING -->
            <div *ngFor="let error of data.validationErrors" class="atdl-validation-error">
              {{error}}
            </div>
          </div>
        </ng-template>
      </p-splitter>
    </div>
  </div>
</div>
